"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AcceptInvitationSceneTranslation = {
    fi: {
        AcceptInvitationScene: {
            button: 'Tallenna',
            title: 'Viimeistele tunnuksesi',
            subTitle: 'Anna salasanasi, niin pääset kirjautumaan.',
            password: 'Salasana',
        },
    },
    en: {
        AcceptInvitationScene: {
            button: 'Save',
            title: 'Setup your password',
            subTitle: 'Setup your password and start using application.',
            password: 'Password',
        },
    },
};
exports.default = AcceptInvitationSceneTranslation;
//# sourceMappingURL=AcceptInvitationScene.translation.js.map